import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'led_mng',
  components: {
    ledTable: function ledTable() {
      return import('./led_page');
    },
    ledParamTable: function ledParamTable() {
      return import('./ledParam_page');
    }
  },
  data: function data() {
    return {
      tableShow: 'led',
      current: {}
    };
  },
  methods: {
    goled: function goled() {
      this.tableShow = 'led';
    },
    goChild: function goChild(data, tableName) {
      this.current = data;
      this.tableShow = tableName;
    }
  }
};